import React from 'react';
import '../../../Static/Master/SalepartyReg.css';

const Pagination = ({ currentPage, handlePageChange, handlePreviousPageRange, visiblePageNumbers, pageNumber, pageRange, totalPages, handleNextPageRange }) => {

    return (
        <>

            <div className='pagination-container'>
                <div className='pagination-box'>
                    <label>Pagination:</label>
                    <ul className='pagination'>
                        <button className='page-link' onClick={() => handlePageChange(currentPage !== 1 ? currentPage - 1 : 1)} disabled={currentPage === 1}>Prev</button>
                        {pageRange[0] > 0 && (
                            <button className='page-link' onClick={handlePreviousPageRange}>&rarr;</button>
                        )}
                        {
                            visiblePageNumbers.map((pageNumber) => (
                                <button
                                    key={pageNumber}
                                    onClick={() => handlePageChange(pageNumber)}
                                    className={`page-link ${currentPage === pageNumber ? 'active' : ''}`}
                                >{pageNumber}</button>
                            ))
                        }

                        {pageRange[1] < totalPages && (
                            <button className='page-link' onClick={handleNextPageRange}>&larr;</button>
                        )}
                        <button className='page-link' onClick={() => handlePageChange(currentPage !== totalPages ? currentPage + 1 : totalPages)} disabled={currentPage === totalPages}>Next</button>
                        {/* <span>Total Entries: {totalCount}</span> */}
                    </ul>
                </div>
            </div>

        </>
    );
};

export default React.memo(Pagination);
